import { type SxProps, type Theme } from '@mui/system';
import { createTheme } from '@mui/material/styles';

const theme = createTheme();

export const courseTitle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  '& .admin-btn': {
    marginLeft: '18px',
    backgroundColor: '#006EC2',
    width: '100px',
    height: '25px',
    textTransform: 'capitalize',
  },
  '& .course-h': {
    color: '#006EC2',
    fontSize: '28px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
};

export const courseActions: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  '& .heading-title': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: '10px',
    cursor: 'pointer',
    marginRight: '40px',
  },
  '& .heading-title-all': {
    fontSize: '18px',
    marginLeft: '10px',
  },
  '& .heading-title-sort': {
    fontSize: '18px',
    marginLeft: '10px',
  },
  '& .course-search': {
    height: '35px',
    border: '1px solid #006EC2',
    width: '280px',
    outline: 'none !important',
    marginLeft: '10px',
    borderRadius: '3px',
    paddingRight: '35px',
  },
  '& button': {
    marginLeft: '25px',
  },
  '& button > span > i': {
    fontSize: '17px !important',
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'space-around',
    '& .heading-title': {
      marginRight: '5px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    '& .course-search': {
      width: 'auto',
      '& button': {
        marginLeft: '5px',
      },
    },
  },
};

export const courseDetail: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '& .course-detail-rating': {
    color: '#006EC2',
    fontSize: '28px',
    fontWeight: 'bold',
    margin: '23px 0px 0px 0px',
  },
  '& .course-detail-score': {
    margin: '16px 0px 0px 0px',
    color: '#006EC2',
    fontSize: '18px',
  },
  '& .course-detail-passing': {
    margin: '8px 0px 0px 0px',
    color: '#006EC2',
    fontSize: '18px',
  },
  '& .course-detail-report': {
    width: '240px',
    height: '40px',
    marginTop: '10px',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    textTransform: 'capitalize',
  },
  '& .CircularProgressbar-background': {
    background: 'white',
  },
  '& .course-detail-score:before': {
    content: '""',
    display: 'inline-block',
    width: '10px',
    height: '10px',
    marginRight: '13.5px',
    backgroundColor: '#006EC2',
    borderRadius: '2px',
  },
  '& .course-detail-passing:before': {
    content: '""',
    display: 'inline-block',
    width: '10px',
    height: '10px',
    marginRight: '11.2px',
    backgroundColor: '#006EC2',
    borderRadius: '2px',
  },
};
